import {React, styled} from 'common'
import {Colors} from 'appearance'
import {menuIcons, routes} from 'constants/sideMenu'
import {useI18n, useIsRtl} from 'store/Store'
import useSideMenuItem from 'logic/Menu/useSideMenuItem'
import {useLocation, useNavigate} from 'react-router-dom'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import {ListItem} from '@mui/material'
import analyticsService from 'services/analytic'

const SideMenuItem = ({item}) => {
    const isRtl = useIsRtl()
    const {i18n} = useI18n()
    const navigate = useNavigate()
    const location = useLocation()
    const {isSelected} = useSideMenuItem(item, location)

    return (
        <ListItem key={item} disablePadding>
            <MenuItemButton
                onClick={() => {
                    navigate(routes[item])
                    analyticsService.navToolPressed(item)
                }}
                selected={isSelected}>
                {menuIcons[item] && (
                    <ListItemIcon style={{color: Colors.PRIMARY_TEXT}}>
                        {menuIcons[item]}
                    </ListItemIcon>
                )}
                <MenuItemText
                    isrtl={isRtl ? 1 : 0}
                    primary={i18n.t(`menu.${item}`)}
                />
            </MenuItemButton>
        </ListItem>
    )
}

export default SideMenuItem

const MenuItemButton = styled(ListItemButton)`
    padding-inline: 45px !important;
    &&.Mui-selected {
        background-color: ${Colors.LIGHT_BLUE};
        & * {
            color: ${Colors.PRIMARY_COLOR};
        }
        &&:hover {
            background-color: ${Colors.LIGHT_BLUE};
        }
    }
`

const MenuItemText = styled(ListItemText)`
    text-align: ${(props) => (props.isrtl ? 'right' : 'left')};
    font-size: 22px;
    font-weight: 700;
    color: ${Colors.PRIMARY_TEXT};
`
